export enum Metric {
  IMPRESSIONS = 'impressions',
  REACH = 'reach',
  FREQUENCY = 'frequency',
  VIDEO_COMPLETES = 'video_completes',
  CLICKS = 'clicks',
  VCR = 'vcr',
  VIDEO_Q1S = 'video_q1s',
  VIDEO_MIDPOINTS = 'video_midpoints',
  VIDEO_Q3S = 'video_q3s',
  VIDEO_PLAYS = 'video_plays',
  CTR = 'ctr',
  IP_CONVERSIONS = 'ip_conversions',
  AUDIO_PLAYS = 'audio_plays',
  AUDIO_COMPLETES = 'audio_completes',
  AUDIO_Q1S = 'audio_q1s',
  AUDIO_MIDPOINTS = 'audio_midpoints',
  AUDIO_Q3S = 'audio_q3s',
  AUDIO_SKIPS = 'audio_skips',
  ACR = 'acr',
  BOOKED = 'booked',
  PACING_TO = 'pacing_to',
  PACING_TO_PERCENT = 'pacing_to_percent',
  CLIENT_SPEND = 'client_spend',
  TOTAL_SPEND = 'total_spend',
  CLIENT_SPEND_CPA = 'client_spend_cpa',
  TOTAL_SPEND_CPA = 'total_spend_cpa',
  SPEND = 'spend',
  CPM = 'cpm',
}

export default Metric;
